import styles from './styles.module.css';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaPhone, FaEnvelope } from "react-icons/fa6";

import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { toastOptions } from 'src/constants/toast';
import LangMenu from 'src/components/LangMenu/LangMenu';



const Footer = () => {
    const { t } = useTranslation("common");

    const links = [
        {
            name: t("footer.links.supplements_list"),
            to: "/supplements"
        },
        {
            name: t("footer.links.about"),
            to: "/about"
        },
        {
            name: t("footer.links.contact"),
            to: "/contact"
        },
        // {
        //     name: t("footer.links.privacy"),
        //     to: "/privacy-policy"
        // }
    ]


    const copyToClipBoard = async (copyMe: string) => {
        try {
            await navigator.clipboard.writeText(copyMe);
            return true;
        } catch (err) {
            return false;
        }
    };

    const phoneCopyHandler = async (phoneNumber: string) => {
        const copied = await copyToClipBoard(phoneNumber);
        if (copied) {
            toast.success(t("footer.copied"), toastOptions);
        } else {
            console.log(t("footer.copy_error"));
        }
    };

    return (
        <section className={styles.footer}>
            <div className="container">
                <div className={"row"}>

                    <div className='col-lg-5 col-12 mb-5 mb-lg-0'>
                        <div className={styles.location}>
                            <h4 className={styles.title}>{t("footer.location")}</h4>
                            <div>
                                <iframe
                                    src="https://maps.google.com/maps?q=32.3772647219099,14.993249666657812&hl=ar&t=&z=18&ie=UTF8&iwloc=B&output=embed"
                                    height="227"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title={t("footer.map_title")}
                                ></iframe>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-1 col-12'>

                    </div>

                    <div className='col-lg-3 col-md-6 col-12  mb-5 mb-lg-0'>

                        <div className={styles.list}>
                            <h4 className={styles.title}>{t("footer.links.title")}</h4>
                            <ul>
                                {links.map((item, index) => (
                                    <li key={`links-key-${index}`}>
                                        <Link className={styles.link} to={item.to}>
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className='col-12 col-lg-3 col-md-6  mb-5 mb-lg-0'>
                        <div className={styles.list}>
                            <h4 className={styles.title}>
                                {t("footer.contact_info")}
                            </h4>
                            <ul>
                                <li>
                                    <span
                                        className={styles.link}
                                        onClick={() => phoneCopyHandler("+218912119580")}
                                    >
                                        <div>
                                            <FaPhone />
                                        </div>
                                        {t("footer.phone1")}
                                    </span>
                                </li>

                                <li>
                                    <a
                                        className={styles.link}
                                        href="mailto:info@ramainternationally.com"
                                    >
                                        <div>
                                            <FaEnvelope />
                                        </div>
                                        {t("footer.main_email")}
                                    </a>
                                </li>

                                <li>
                                    <a
                                        className={styles.link}
                                        href="mailto:khaled@ramainternationally.com"
                                    >
                                        <div>
                                            <FaEnvelope />
                                        </div>
                                        {t("footer.sales_email")}
                                    </a>
                                </li>

                                <li>
                                    <a
                                        className={styles.link}
                                        href="mailto:omar@ramainternationally.com"
                                    >
                                        <div>
                                            <FaEnvelope />
                                        </div>
                                        {t("footer.external_email")}
                                    </a>
                                </li>

                                <li>
                                    <a
                                        className={styles.link}
                                        href="https://www.facebook.com/p/%D8%B4%D8%B1%D9%83%D8%A9-%D8%B1%D8%A7%D9%85%D8%A7-%D9%84%D8%A5%D8%B3%D8%AA%D9%8A%D8%B1%D8%A7%D8%AF-%D8%A7%D9%84%D8%A7%D8%AF%D9%88%D9%8A%D8%A9-100087132518458/?locale=ar_AR"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <div>
                                            <FaFacebookF />
                                        </div>
                                        {t("footer.facebook")}
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
                <div className={styles.copyright}>
                    <LangMenu />
                    <div>{t("footer.copyright")}</div>
                </div>
            </div>
        </section>
    );
};

export default Footer;
